import { render, staticRenderFns } from "./groceryMarket.vue?vue&type=template&id=73059c56&scoped=true"
import script from "./groceryMarket.vue?vue&type=script&lang=js"
export * from "./groceryMarket.vue?vue&type=script&lang=js"
import style0 from "./groceryMarket.vue?vue&type=style&index=0&id=73059c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73059c56",
  null
  
)

export default component.exports